import React from 'react'
import PropTypes from 'prop-types'

export function InputDefaultBase ({
  size = 'full',
  title,
  description,
  type = 'text',
  name,
  value,
  onChange,
  min,
  max,
  ...other
}) {
  return (
    <aside className={'input input-text input-box'} data-size={size}>
      <label>
        {title ? <div className={'input-box__title'}>{title}</div> : null} {description}
      </label>
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        min={min}
        max={max}
        {...other}
      />
    </aside>
  )
}

InputDefaultBase.propTypes = {
  size: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  min: PropTypes.number,
  max: PropTypes.number
}
